
import React from "react";

import { IconButton, Tooltip } from "@mui/material"
import { Settings } from "@mui/icons-material"
import { iconos } from "../../../data"




export const TooltipAndIcon = ({ titulo, icono, onClick, color='#2979ff', size=15, disabled=false }) => {


    return (
        <Tooltip title={disabled ? '' : titulo} placement="top">
            <IconButton onClick={onClick} size="small" disabled={disabled}
                sx={{ color:'primary.main', '&.Mui-disabled': {backgroundColor:'grey.300'}
            }}>
                {React.cloneElement(iconos[icono] || <Settings />, { style:{ color:(disabled) ? 'black' : color, fontSize:`${size}px` }})}
            </IconButton>
        </Tooltip>

    )
}
